import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect, useCallback } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Button from '../Button/index.esm.js';
import Flex from '../Flex/index.esm.js';
import '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import HintsContextProvider, { useHintsContext } from './context.esm.js';
import '../../hooks/use-hints.esm.js';
import '../../hooks/use-input-style.esm.js';
import { useKeyPress } from '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import Portal from '../Portal/index.esm.js';
import Tooltip from '../Tooltip/index.esm.js';
import Transition from '../Transition/index.esm.js';

var Hints = function Hints(_ref) {
  var children = _ref.children,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose;

  var _useState = useState(),
      visibleGroup = _useState[0],
      setVisibleGroup = _useState[1];

  var _useState2 = useState(false),
      showAnimation = _useState2[0],
      setShowAnimation = _useState2[1];

  var escKeyPressed = useKeyPress('Escape');
  useEffect(function () {
    if (escKeyPressed && visibleGroup) {
      setVisibleGroup(undefined);
    }
  }, [escKeyPressed]);
  useEffect(function () {
    var timeoutId;

    if (showAnimation) {
      timeoutId = window.setTimeout(function () {
        return setShowAnimation(false);
      }, 350);
    }

    return function () {
      clearTimeout(timeoutId);
    };
  }, [showAnimation]);
  var closeHints = useCallback(function () {
    onClose(visibleGroup);
    setVisibleGroup(undefined);
  }, [onClose]);
  return React__default.createElement(HintsContextProvider, {
    value: {
      visibleGroup: visibleGroup,
      setVisibleGroup: setVisibleGroup
    }
  }, children, React__default.createElement(Portal, null, React__default.createElement(Transition, {
    show: Boolean(visibleGroup),
    enter: ['ease-in-out', 'duration-100'],
    enterFrom: ['opacity-0'],
    enterTo: ['opacity-100'],
    leave: ['ease-in-out', 'duration-100'],
    leaveFrom: ['opacity-100'],
    leaveTo: ['opacity-0']
  }, React__default.createElement(Flex, {
    id: "sajari-hints-container",
    onClick: function onClick() {
      return setShowAnimation(true);
    },
    transitionProperty: "transition-opacity",
    transform: "transform",
    zIndex: "z-40",
    width: "w-screen",
    height: "h-screen",
    inset: ['top-0', 'left-0'],
    backgroundColor: "bg-white",
    backgroundOpacity: "bg-opacity-50",
    position: "fixed",
    justifyContent: "justify-center"
  }, React__default.createElement(Button, {
    animation: showAnimation ? 'animate-wiggle' : undefined,
    onClick: closeHints,
    iconBefore: "close",
    borderRadius: "rounded-full",
    appearance: "primary",
    position: "absolute",
    inset: "bottom-10",
    zIndex: "z-60"
  }, "Hide hints")))));
};

Hints.Hint = /*#__PURE__*/React__default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      group = _ref2.group,
      rest = _objectWithoutPropertiesLoose(_ref2, ["children", "group"]);

  var _useHintsContext = useHintsContext(),
      visibleGroup = _useHintsContext.visibleGroup;

  if (!visibleGroup || visibleGroup !== group) {
    return React__default.cloneElement(children, {
      ref: ref
    });
  }

  return React__default.createElement(Tooltip, _extends({
    getPortalContainer: function getPortalContainer() {
      return document.querySelector('#sajari-hints-container');
    },
    backgroundColor: "bg-hint",
    textColor: "text-white"
  }, rest, {
    open: true
  }), children);
});

if (__DEV__) {
  Hints.displayName = 'Hints';
}

export default Hints;
//# sourceMappingURL=index.esm.js.map
